module.exports = __webpack_public_path__ + "img/trophy-two.5848924c.svg";